/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAccountingBankAccount } from 'app/shared/model/accounting-bank-account.model';
import { IAccountingTransaction } from 'app/shared/model/accounting-transaction.model';

export interface IAccountingReconciliation {
  id?: string;
  startDate?: number;
  endDate?: number;
  closingBalance?: number;
  difference?: number;
  reconciled?: boolean | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  account?: IAccountingBankAccount | null;
  transactions?: IAccountingTransaction[] | null;
}

export const defaultValue: Readonly<IAccountingReconciliation> = {
  reconciled: false,
  active: false,
};
